'use client';
import React, { useState } from 'react';
import { Mail, Send, Shield } from 'lucide-react';

const Newsletter = () => {
    const [email, setEmail] = useState('');
    const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setStatus('loading');

        try {
            const res = await fetch('/api/subscribe', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email })
            });

            if (res.ok) setStatus('success');
            else setStatus('error');
        } catch (err) {
            setStatus('error');
        }
    };

    return (
        <section style={{
            margin: '4rem 0',
            padding: 'clamp(2rem, 8vw, 5rem) 1.5rem',
            background: '#0f172a',
            borderRadius: '48px',
            position: 'relative',
            overflow: 'hidden',
            color: '#fff'
        }}>
            <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: '4px', background: 'linear-gradient(90deg, #2563eb, #60a5fa, #2563eb)' }} />

            <div style={{ maxWidth: '800px', margin: '0 auto', textAlign: 'center' }}>
                <div style={{
                    display: 'inline-flex',
                    padding: '0.75rem',
                    background: 'rgba(37, 99, 235, 0.1)',
                    borderRadius: '20px',
                    color: '#3b82f6',
                    marginBottom: '1.5rem',
                    border: '1px solid rgba(37, 99, 235, 0.2)'
                }}>
                    <Mail size={24} />
                </div>

                <h2 style={{ fontSize: 'var(--fs-3xl)', fontWeight: 900, marginBottom: '1.25rem', letterSpacing: '-0.04em', color: '#ffffff' }}>
                    The Industrial Intelligence Report
                </h2>
                <p style={{ fontSize: 'var(--fs-lg)', color: '#94a3b8', marginBottom: '3rem', lineHeight: 1.6 }}>
                    Join 12,000+ professionals receiving weekly insights on digital sovereignty,
                    AI prompt engineering, and high-performance utility workflows.
                </p>

                {status === 'success' ? (
                    <div style={{ padding: '2rem', background: 'rgba(16, 185, 129, 0.1)', border: '1px solid #10b981', borderRadius: '24px', color: '#10b981', fontWeight: 700 }}>
                        Welcome to the Inner Circle. Your first briefing is on its way.
                    </div>
                ) : (
                    <form onSubmit={handleSubmit} style={{
                        display: 'flex',
                        gap: '0.75rem',
                        flexWrap: 'wrap',
                        background: 'rgba(255,255,255,0.03)',
                        padding: '0.5rem',
                        borderRadius: '24px',
                        border: '1px solid rgba(255,255,255,0.1)'
                    }}>
                        <input
                            type="email"
                            placeholder="Enter your professional email..."
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            style={{
                                flex: 1,
                                minWidth: '280px',
                                background: 'transparent',
                                border: 'none',
                                padding: '1rem 1.5rem',
                                color: '#fff',
                                fontSize: '1rem',
                                outline: 'none'
                            }}
                        />
                        <button
                            type="submit"
                            disabled={status === 'loading'}
                            className="btn-primary"
                            style={{
                                padding: '1rem 2.5rem',
                                borderRadius: '18px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '0.75rem',
                                width: 'min(100%, 200px)',
                                justifyContent: 'center'
                            }}
                        >
                            {status === 'loading' ? 'Processing...' : (
                                <>
                                    Join Now <Send size={18} />
                                </>
                            )}
                        </button>
                    </form>
                )}

                <div style={{ marginTop: '2.5rem', display: 'flex', justifyContent: 'center', gap: '2rem', opacity: 0.6 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '0.85rem' }}>
                        <Shield size={16} /> 100% Secure
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '0.85rem' }}>
                        <Shield size={16} /> No Spam
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '0.85rem' }}>
                        <Shield size={16} /> One-Click Unsubscribe
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Newsletter;
